//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import ApiConfig from './apiConfig';import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class UserClient extends ApiConfig {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("http://localhost:7061");

    }

    /**
     * @param body (optional) 
     * @return Payload of UserInformation
     */
    getUser(body: UserRequest | null | undefined, cancelToken?: CancelToken): Promise<UserInformation> {
        let url_ = this.baseUrl + "/user/getUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserInformation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserInformation.fromJS(resultData200);
            return Promise.resolve<UserInformation>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserInformation>(null as any);
    }
}

export class ProductClient extends ApiConfig {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("http://localhost:7061");

    }

    /**
     * @param body (optional) 
     * @return Payload of Array of ProductInformation
     */
    getProducts(body: ProductInformationRequest | null | undefined, cancelToken?: CancelToken): Promise<ProductInformation[]> {
        let url_ = this.baseUrl + "/products/getProducts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<ProductInformation[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInformation.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProductInformation[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductInformation[]>(null as any);
    }
}

export class OrderClient extends ApiConfig {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? this.getBaseUrl("http://localhost:7061");

    }

    /**
     * @param body (optional) 
     * @return Payload of CreatedOrder
     */
    createOrder(body: CreateOrderRequest | null | undefined, cancelToken?: CancelToken): Promise<CreatedOrder> {
        let url_ = this.baseUrl + "/order/createOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateOrder(_response);
        });
    }

    protected processCreateOrder(response: AxiosResponse): Promise<CreatedOrder> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreatedOrder.fromJS(resultData200);
            return Promise.resolve<CreatedOrder>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreatedOrder>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Payload of Array of DeliveryAddress
     */
    getDeliveryAdress(body: GetDeliveryAddressRequest | null | undefined, cancelToken?: CancelToken): Promise<DeliveryAddress[]> {
        let url_ = this.baseUrl + "/order/GetDeliveryAddress";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDeliveryAdress(_response);
        });
    }

    protected processGetDeliveryAdress(response: AxiosResponse): Promise<DeliveryAddress[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliveryAddress.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DeliveryAddress[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeliveryAddress[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Payload of OrdersInfo
     */
    getOrder(body: GetOrderRequest | null | undefined, cancelToken?: CancelToken): Promise<OrdersInfo> {
        let url_ = this.baseUrl + "/order/GetOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrder(_response);
        });
    }

    protected processGetOrder(response: AxiosResponse): Promise<OrdersInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrdersInfo.fromJS(resultData200);
            return Promise.resolve<OrdersInfo>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrdersInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Payload of Array of Orders
     */
    getOrders(body: GetOrdersRequest | null | undefined, cancelToken?: CancelToken): Promise<Orders[]> {
        let url_ = this.baseUrl + "/order/GetOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrders(_response);
        });
    }

    protected processGetOrders(response: AxiosResponse): Promise<Orders[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Orders.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Orders[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Orders[]>(null as any);
    }
}

export class ArtWork implements IArtWork {
    part?: string | undefined;
    id?: string | undefined;

    constructor(data?: IArtWork) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.part = _data["part"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArtWork {
        data = typeof data === 'object' ? data : {};
        let result = new ArtWork();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["part"] = this.part;
        data["id"] = this.id;
        return data;
    }
}

export interface IArtWork {
    part?: string | undefined;
    id?: string | undefined;
}

export class ArtworkVersionDto implements IArtworkVersionDto {
    supplierNumber?: string | undefined;
    dateFinalized?: Date | undefined;
    isFinalized?: boolean | undefined;
    part?: string | undefined;
    version?: number | undefined;
    borrowed?: boolean | undefined;
    articleId?: string | undefined;
    artworkId?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IArtworkVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierNumber = _data["supplierNumber"];
            this.dateFinalized = _data["dateFinalized"] ? new Date(_data["dateFinalized"].toString()) : <any>undefined;
            this.isFinalized = _data["isFinalized"];
            this.part = _data["part"];
            this.version = _data["version"];
            this.borrowed = _data["borrowed"];
            this.articleId = _data["articleId"];
            this.artworkId = _data["artworkId"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ArtworkVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArtworkVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierNumber"] = this.supplierNumber;
        data["dateFinalized"] = this.dateFinalized ? this.dateFinalized.toISOString() : <any>undefined;
        data["isFinalized"] = this.isFinalized;
        data["part"] = this.part;
        data["version"] = this.version;
        data["borrowed"] = this.borrowed;
        data["articleId"] = this.articleId;
        data["artworkId"] = this.artworkId;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IArtworkVersionDto {
    supplierNumber?: string | undefined;
    dateFinalized?: Date | undefined;
    isFinalized?: boolean | undefined;
    part?: string | undefined;
    version?: number | undefined;
    borrowed?: boolean | undefined;
    articleId?: string | undefined;
    artworkId?: string | undefined;
    id?: string | undefined;
    name?: string | undefined;
}

export class BioGaiaContact implements IBioGaiaContact {
    firstName?: string | undefined;
    lastName?: string | undefined;
    internalEmailAddress?: string | undefined;
    mobilePhone?: string | undefined;

    constructor(data?: IBioGaiaContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.internalEmailAddress = _data["internalEmailAddress"];
            this.mobilePhone = _data["mobilePhone"];
        }
    }

    static fromJS(data: any): BioGaiaContact {
        data = typeof data === 'object' ? data : {};
        let result = new BioGaiaContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["internalEmailAddress"] = this.internalEmailAddress;
        data["mobilePhone"] = this.mobilePhone;
        return data;
    }
}

export interface IBioGaiaContact {
    firstName?: string | undefined;
    lastName?: string | undefined;
    internalEmailAddress?: string | undefined;
    mobilePhone?: string | undefined;
}

export class Company implements ICompany {
    companyName?: string | undefined;
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    kamInfo?: BioGaiaContact | undefined;
    samInfo?: BioGaiaContact | undefined;
    ramInfo?: BioGaiaContact | undefined;
    artwork?: string | undefined;
    currency?: string | undefined;

    constructor(data?: ICompany) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.accountId = _data["accountId"];
            this.kamInfo = _data["kamInfo"] ? BioGaiaContact.fromJS(_data["kamInfo"]) : <any>undefined;
            this.samInfo = _data["samInfo"] ? BioGaiaContact.fromJS(_data["samInfo"]) : <any>undefined;
            this.ramInfo = _data["ramInfo"] ? BioGaiaContact.fromJS(_data["ramInfo"]) : <any>undefined;
            this.artwork = _data["artwork"];
            this.currency = _data["currency"];
        }
    }

    static fromJS(data: any): Company {
        data = typeof data === 'object' ? data : {};
        let result = new Company();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["accountId"] = this.accountId;
        data["kamInfo"] = this.kamInfo ? this.kamInfo.toJSON() : <any>undefined;
        data["samInfo"] = this.samInfo ? this.samInfo.toJSON() : <any>undefined;
        data["ramInfo"] = this.ramInfo ? this.ramInfo.toJSON() : <any>undefined;
        data["artwork"] = this.artwork;
        data["currency"] = this.currency;
        return data;
    }
}

export interface ICompany {
    companyName?: string | undefined;
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    kamInfo?: BioGaiaContact | undefined;
    samInfo?: BioGaiaContact | undefined;
    ramInfo?: BioGaiaContact | undefined;
    artwork?: string | undefined;
    currency?: string | undefined;
}

export class CreatedOrder implements ICreatedOrder {
    orderCreated?: boolean | undefined;

    constructor(data?: ICreatedOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderCreated = _data["orderCreated"];
        }
    }

    static fromJS(data: any): CreatedOrder {
        data = typeof data === 'object' ? data : {};
        let result = new CreatedOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderCreated"] = this.orderCreated;
        return data;
    }
}

export interface ICreatedOrder {
    orderCreated?: boolean | undefined;
}

export class CreateOrderRequest implements ICreateOrderRequest {
    customerAccountNumber?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    currency?: string | undefined;
    totalAmount?: number | undefined;
    message?: string | undefined;
    orderReference?: string | undefined;
    orderDate?: Date | undefined;
    accountId?: string | undefined;
    contactId?: string | undefined;
    deliveryAddress?: DeliveryAddress | undefined;
    orderLines?: OrderLines[] | undefined;

    constructor(data?: ICreateOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.companyName = _data["companyName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.currency = _data["currency"];
            this.totalAmount = _data["totalAmount"];
            this.message = _data["message"];
            this.orderReference = _data["orderReference"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.accountId = _data["accountId"];
            this.contactId = _data["contactId"];
            this.deliveryAddress = _data["deliveryAddress"] ? DeliveryAddress.fromJS(_data["deliveryAddress"]) : <any>undefined;
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(OrderLines.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["companyName"] = this.companyName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["currency"] = this.currency;
        data["totalAmount"] = this.totalAmount;
        data["message"] = this.message;
        data["orderReference"] = this.orderReference;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["accountId"] = this.accountId;
        data["contactId"] = this.contactId;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrderRequest {
    customerAccountNumber?: string | undefined;
    companyName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    currency?: string | undefined;
    totalAmount?: number | undefined;
    message?: string | undefined;
    orderReference?: string | undefined;
    orderDate?: Date | undefined;
    accountId?: string | undefined;
    contactId?: string | undefined;
    deliveryAddress?: DeliveryAddress | undefined;
    orderLines?: OrderLines[] | undefined;
}

export class DeliveryAddress implements IDeliveryAddress {
    addressCity?: string | undefined;
    addressDescription?: string | undefined;
    addressCountryRegionId?: string | undefined;
    addressZipCode?: string | undefined;
    addressStreet?: string | undefined;

    constructor(data?: IDeliveryAddress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.addressCity = _data["addressCity"];
            this.addressDescription = _data["addressDescription"];
            this.addressCountryRegionId = _data["addressCountryRegionId"];
            this.addressZipCode = _data["addressZipCode"];
            this.addressStreet = _data["addressStreet"];
        }
    }

    static fromJS(data: any): DeliveryAddress {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryAddress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["addressCity"] = this.addressCity;
        data["addressDescription"] = this.addressDescription;
        data["addressCountryRegionId"] = this.addressCountryRegionId;
        data["addressZipCode"] = this.addressZipCode;
        data["addressStreet"] = this.addressStreet;
        return data;
    }
}

export interface IDeliveryAddress {
    addressCity?: string | undefined;
    addressDescription?: string | undefined;
    addressCountryRegionId?: string | undefined;
    addressZipCode?: string | undefined;
    addressStreet?: string | undefined;
}

export class DiscountInfo implements IDiscountInfo {
    fromQuantity?: number | undefined;
    toQuantity?: number | undefined;
    discount?: number | undefined;

    constructor(data?: IDiscountInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromQuantity = _data["fromQuantity"];
            this.toQuantity = _data["toQuantity"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): DiscountInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromQuantity"] = this.fromQuantity;
        data["toQuantity"] = this.toQuantity;
        data["discount"] = this.discount;
        return data;
    }
}

export interface IDiscountInfo {
    fromQuantity?: number | undefined;
    toQuantity?: number | undefined;
    discount?: number | undefined;
}

export class GetDeliveryAddressRequest implements IGetDeliveryAddressRequest {
    customerAccountNumber?: string | undefined;

    constructor(data?: IGetDeliveryAddressRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNumber = _data["customerAccountNumber"];
        }
    }

    static fromJS(data: any): GetDeliveryAddressRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetDeliveryAddressRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNumber"] = this.customerAccountNumber;
        return data;
    }
}

export interface IGetDeliveryAddressRequest {
    customerAccountNumber?: string | undefined;
}

export class GetOrderRequest implements IGetOrderRequest {
    orderNumber?: string | undefined;

    constructor(data?: IGetOrderRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderNumber = _data["orderNumber"];
        }
    }

    static fromJS(data: any): GetOrderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderNumber"] = this.orderNumber;
        return data;
    }
}

export interface IGetOrderRequest {
    orderNumber?: string | undefined;
}

export class GetOrdersRequest implements IGetOrdersRequest {
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    allOrders?: boolean | undefined;

    constructor(data?: IGetOrdersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.accountId = _data["accountId"];
            this.allOrders = _data["allOrders"];
        }
    }

    static fromJS(data: any): GetOrdersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrdersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["accountId"] = this.accountId;
        data["allOrders"] = this.allOrders;
        return data;
    }
}

export interface IGetOrdersRequest {
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    allOrders?: boolean | undefined;
}

export class OrderInfoLines implements IOrderInfoLines {
    orderId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    itemPrice?: number | undefined;
    itemDiscount?: string | undefined;
    totalPrice?: number | undefined;
    canceled?: boolean | undefined;
    confirmedShippingDate?: Date | undefined;
    requestedDeliveryDate?: Date | undefined;
    requestedShippingDate?: Date | undefined;
    shippingDate?: Date | undefined;
    dateofCreation?: Date | undefined;
    comment?: string | undefined;
    artworkVersion_Box?: string | undefined;
    artworkVersion_Label?: string | undefined;
    artworkVersion_Leaflet?: string | undefined;
    artworkVersion_Sachet?: string | undefined;
    artworkVersion_ShipperLabel?: string | undefined;
    artworkVersion_ShipperCarton?: string | undefined;
    artworkVersion_Blister?: string | undefined;
    artworkVersion_PalletLabel?: string | undefined;
    artworkVersion_WrapLabel?: string | undefined;
    artworkVersion_WhiteboxLabel?: string | undefined;

    constructor(data?: IOrderInfoLines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.productId = _data["productId"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.itemPrice = _data["itemPrice"];
            this.itemDiscount = _data["itemDiscount"];
            this.totalPrice = _data["totalPrice"];
            this.canceled = _data["canceled"];
            this.confirmedShippingDate = _data["confirmedShippingDate"] ? new Date(_data["confirmedShippingDate"].toString()) : <any>undefined;
            this.requestedDeliveryDate = _data["requestedDeliveryDate"] ? new Date(_data["requestedDeliveryDate"].toString()) : <any>undefined;
            this.requestedShippingDate = _data["requestedShippingDate"] ? new Date(_data["requestedShippingDate"].toString()) : <any>undefined;
            this.shippingDate = _data["shippingDate"] ? new Date(_data["shippingDate"].toString()) : <any>undefined;
            this.dateofCreation = _data["dateofCreation"] ? new Date(_data["dateofCreation"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.artworkVersion_Box = _data["artworkVersion_Box"];
            this.artworkVersion_Label = _data["artworkVersion_Label"];
            this.artworkVersion_Leaflet = _data["artworkVersion_Leaflet"];
            this.artworkVersion_Sachet = _data["artworkVersion_Sachet"];
            this.artworkVersion_ShipperLabel = _data["artworkVersion_ShipperLabel"];
            this.artworkVersion_ShipperCarton = _data["artworkVersion_ShipperCarton"];
            this.artworkVersion_Blister = _data["artworkVersion_Blister"];
            this.artworkVersion_PalletLabel = _data["artworkVersion_PalletLabel"];
            this.artworkVersion_WrapLabel = _data["artworkVersion_WrapLabel"];
            this.artworkVersion_WhiteboxLabel = _data["artworkVersion_WhiteboxLabel"];
        }
    }

    static fromJS(data: any): OrderInfoLines {
        data = typeof data === 'object' ? data : {};
        let result = new OrderInfoLines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["productId"] = this.productId;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["itemPrice"] = this.itemPrice;
        data["itemDiscount"] = this.itemDiscount;
        data["totalPrice"] = this.totalPrice;
        data["canceled"] = this.canceled;
        data["confirmedShippingDate"] = this.confirmedShippingDate ? this.confirmedShippingDate.toISOString() : <any>undefined;
        data["requestedDeliveryDate"] = this.requestedDeliveryDate ? this.requestedDeliveryDate.toISOString() : <any>undefined;
        data["requestedShippingDate"] = this.requestedShippingDate ? this.requestedShippingDate.toISOString() : <any>undefined;
        data["shippingDate"] = this.shippingDate ? this.shippingDate.toISOString() : <any>undefined;
        data["dateofCreation"] = this.dateofCreation ? this.dateofCreation.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["artworkVersion_Box"] = this.artworkVersion_Box;
        data["artworkVersion_Label"] = this.artworkVersion_Label;
        data["artworkVersion_Leaflet"] = this.artworkVersion_Leaflet;
        data["artworkVersion_Sachet"] = this.artworkVersion_Sachet;
        data["artworkVersion_ShipperLabel"] = this.artworkVersion_ShipperLabel;
        data["artworkVersion_ShipperCarton"] = this.artworkVersion_ShipperCarton;
        data["artworkVersion_Blister"] = this.artworkVersion_Blister;
        data["artworkVersion_PalletLabel"] = this.artworkVersion_PalletLabel;
        data["artworkVersion_WrapLabel"] = this.artworkVersion_WrapLabel;
        data["artworkVersion_WhiteboxLabel"] = this.artworkVersion_WhiteboxLabel;
        return data;
    }
}

export interface IOrderInfoLines {
    orderId?: string | undefined;
    productId?: string | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    itemPrice?: number | undefined;
    itemDiscount?: string | undefined;
    totalPrice?: number | undefined;
    canceled?: boolean | undefined;
    confirmedShippingDate?: Date | undefined;
    requestedDeliveryDate?: Date | undefined;
    requestedShippingDate?: Date | undefined;
    shippingDate?: Date | undefined;
    dateofCreation?: Date | undefined;
    comment?: string | undefined;
    artworkVersion_Box?: string | undefined;
    artworkVersion_Label?: string | undefined;
    artworkVersion_Leaflet?: string | undefined;
    artworkVersion_Sachet?: string | undefined;
    artworkVersion_ShipperLabel?: string | undefined;
    artworkVersion_ShipperCarton?: string | undefined;
    artworkVersion_Blister?: string | undefined;
    artworkVersion_PalletLabel?: string | undefined;
    artworkVersion_WrapLabel?: string | undefined;
    artworkVersion_WhiteboxLabel?: string | undefined;
}

export class OrderLines implements IOrderLines {
    productNumber?: number | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    price?: number | undefined;
    discount?: number | undefined;
    requestedDeliveryDate?: Date | undefined;
    comment?: string | undefined;
    selectedArtWork?: ArtWork[] | undefined;

    constructor(data?: IOrderLines) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productNumber = _data["productNumber"];
            this.productName = _data["productName"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.discount = _data["discount"];
            this.requestedDeliveryDate = _data["requestedDeliveryDate"] ? new Date(_data["requestedDeliveryDate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            if (Array.isArray(_data["selectedArtWork"])) {
                this.selectedArtWork = [] as any;
                for (let item of _data["selectedArtWork"])
                    this.selectedArtWork!.push(ArtWork.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrderLines {
        data = typeof data === 'object' ? data : {};
        let result = new OrderLines();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productNumber"] = this.productNumber;
        data["productName"] = this.productName;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["discount"] = this.discount;
        data["requestedDeliveryDate"] = this.requestedDeliveryDate ? this.requestedDeliveryDate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        if (Array.isArray(this.selectedArtWork)) {
            data["selectedArtWork"] = [];
            for (let item of this.selectedArtWork)
                data["selectedArtWork"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrderLines {
    productNumber?: number | undefined;
    productName?: string | undefined;
    quantity?: number | undefined;
    price?: number | undefined;
    discount?: number | undefined;
    requestedDeliveryDate?: Date | undefined;
    comment?: string | undefined;
    selectedArtWork?: ArtWork[] | undefined;
}

export class Orders implements IOrders {
    orderId?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    subTotal?: number | undefined;
    currency?: string | undefined;
    orderReference?: string | undefined;
    orderStatus?: number | undefined;

    constructor(data?: IOrders) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderNumber = _data["orderNumber"];
            this.subTotal = _data["subTotal"];
            this.currency = _data["currency"];
            this.orderReference = _data["orderReference"];
            this.orderStatus = _data["orderStatus"];
        }
    }

    static fromJS(data: any): Orders {
        data = typeof data === 'object' ? data : {};
        let result = new Orders();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderNumber"] = this.orderNumber;
        data["subTotal"] = this.subTotal;
        data["currency"] = this.currency;
        data["orderReference"] = this.orderReference;
        data["orderStatus"] = this.orderStatus;
        return data;
    }
}

export interface IOrders {
    orderId?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    subTotal?: number | undefined;
    currency?: string | undefined;
    orderReference?: string | undefined;
    orderStatus?: number | undefined;
}

export class OrdersInfo implements IOrdersInfo {
    orderId?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    totalDiscount?: number | undefined;
    subTotal?: number | undefined;
    currency?: string | undefined;
    orderStatus?: number | undefined;
    message?: string | undefined;
    orderReference?: string | undefined;
    deliveryAddress?: DeliveryAddress | undefined;
    orderLines?: OrderInfoLines[] | undefined;

    constructor(data?: IOrdersInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : <any>undefined;
            this.orderNumber = _data["orderNumber"];
            this.totalDiscount = _data["totalDiscount"];
            this.subTotal = _data["subTotal"];
            this.currency = _data["currency"];
            this.orderStatus = _data["orderStatus"];
            this.message = _data["message"];
            this.orderReference = _data["orderReference"];
            this.deliveryAddress = _data["deliveryAddress"] ? DeliveryAddress.fromJS(_data["deliveryAddress"]) : <any>undefined;
            if (Array.isArray(_data["orderLines"])) {
                this.orderLines = [] as any;
                for (let item of _data["orderLines"])
                    this.orderLines!.push(OrderInfoLines.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrdersInfo {
        data = typeof data === 'object' ? data : {};
        let result = new OrdersInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : <any>undefined;
        data["orderNumber"] = this.orderNumber;
        data["totalDiscount"] = this.totalDiscount;
        data["subTotal"] = this.subTotal;
        data["currency"] = this.currency;
        data["orderStatus"] = this.orderStatus;
        data["message"] = this.message;
        data["orderReference"] = this.orderReference;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : <any>undefined;
        if (Array.isArray(this.orderLines)) {
            data["orderLines"] = [];
            for (let item of this.orderLines)
                data["orderLines"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrdersInfo {
    orderId?: string | undefined;
    orderDate?: Date | undefined;
    orderNumber?: string | undefined;
    totalDiscount?: number | undefined;
    subTotal?: number | undefined;
    currency?: string | undefined;
    orderStatus?: number | undefined;
    message?: string | undefined;
    orderReference?: string | undefined;
    deliveryAddress?: DeliveryAddress | undefined;
    orderLines?: OrderInfoLines[] | undefined;
}

export class PriceInfo implements IPriceInfo {
    fromQuantity?: number | undefined;
    toQuantity?: number | undefined;
    price?: number | undefined;
    discount?: number | undefined;

    constructor(data?: IPriceInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromQuantity = _data["fromQuantity"];
            this.toQuantity = _data["toQuantity"];
            this.price = _data["price"];
            this.discount = _data["discount"];
        }
    }

    static fromJS(data: any): PriceInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PriceInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromQuantity"] = this.fromQuantity;
        data["toQuantity"] = this.toQuantity;
        data["price"] = this.price;
        data["discount"] = this.discount;
        return data;
    }
}

export interface IPriceInfo {
    fromQuantity?: number | undefined;
    toQuantity?: number | undefined;
    price?: number | undefined;
    discount?: number | undefined;
}

export class ProductInformation implements IProductInformation {
    itemId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moq?: number | undefined;
    currency?: string | undefined;
    priceRules?: PriceInfo[] | undefined;
    discounts?: DiscountInfo[] | undefined;
    customerProductName?: string | undefined;
    customerProductNumber?: string | undefined;
    productPackagingName?: string | undefined;
    artworks?: ArtworkVersionDto[] | undefined;
    errorMessage?: string | undefined;
    cannotParse?: boolean | undefined;

    constructor(data?: IProductInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.itemId = _data["itemId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.moq = _data["moq"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["priceRules"])) {
                this.priceRules = [] as any;
                for (let item of _data["priceRules"])
                    this.priceRules!.push(PriceInfo.fromJS(item));
            }
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [] as any;
                for (let item of _data["discounts"])
                    this.discounts!.push(DiscountInfo.fromJS(item));
            }
            this.customerProductName = _data["customerProductName"];
            this.customerProductNumber = _data["customerProductNumber"];
            this.productPackagingName = _data["productPackagingName"];
            if (Array.isArray(_data["artworks"])) {
                this.artworks = [] as any;
                for (let item of _data["artworks"])
                    this.artworks!.push(ArtworkVersionDto.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
            this.cannotParse = _data["cannotParse"];
        }
    }

    static fromJS(data: any): ProductInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["itemId"] = this.itemId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["moq"] = this.moq;
        data["currency"] = this.currency;
        if (Array.isArray(this.priceRules)) {
            data["priceRules"] = [];
            for (let item of this.priceRules)
                data["priceRules"].push(item.toJSON());
        }
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        data["customerProductName"] = this.customerProductName;
        data["customerProductNumber"] = this.customerProductNumber;
        data["productPackagingName"] = this.productPackagingName;
        if (Array.isArray(this.artworks)) {
            data["artworks"] = [];
            for (let item of this.artworks)
                data["artworks"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        data["cannotParse"] = this.cannotParse;
        return data;
    }
}

export interface IProductInformation {
    itemId?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    moq?: number | undefined;
    currency?: string | undefined;
    priceRules?: PriceInfo[] | undefined;
    discounts?: DiscountInfo[] | undefined;
    customerProductName?: string | undefined;
    customerProductNumber?: string | undefined;
    productPackagingName?: string | undefined;
    artworks?: ArtworkVersionDto[] | undefined;
    errorMessage?: string | undefined;
    cannotParse?: boolean | undefined;
}

export class ProductInformationRequest implements IProductInformationRequest {
    customerAccountNumber?: string | undefined;

    constructor(data?: IProductInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountNumber = _data["customerAccountNumber"];
        }
    }

    static fromJS(data: any): ProductInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountNumber"] = this.customerAccountNumber;
        return data;
    }
}

export interface IProductInformationRequest {
    customerAccountNumber?: string | undefined;
}

export class UserInformation implements IUserInformation {
    orderPortalAccess?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    contactId?: string | undefined;
    kamInfo?: BioGaiaContact | undefined;
    samInfo?: BioGaiaContact | undefined;
    artwork?: string | undefined;
    currency?: string | undefined;
    companies?: Company[] | undefined;

    constructor(data?: IUserInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderPortalAccess = _data["orderPortalAccess"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.companyName = _data["companyName"];
            this.customerAccountNumber = _data["customerAccountNumber"];
            this.accountId = _data["accountId"];
            this.contactId = _data["contactId"];
            this.kamInfo = _data["kamInfo"] ? BioGaiaContact.fromJS(_data["kamInfo"]) : <any>undefined;
            this.samInfo = _data["samInfo"] ? BioGaiaContact.fromJS(_data["samInfo"]) : <any>undefined;
            this.artwork = _data["artwork"];
            this.currency = _data["currency"];
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(Company.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserInformation {
        data = typeof data === 'object' ? data : {};
        let result = new UserInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderPortalAccess"] = this.orderPortalAccess;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["companyName"] = this.companyName;
        data["customerAccountNumber"] = this.customerAccountNumber;
        data["accountId"] = this.accountId;
        data["contactId"] = this.contactId;
        data["kamInfo"] = this.kamInfo ? this.kamInfo.toJSON() : <any>undefined;
        data["samInfo"] = this.samInfo ? this.samInfo.toJSON() : <any>undefined;
        data["artwork"] = this.artwork;
        data["currency"] = this.currency;
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserInformation {
    orderPortalAccess?: boolean | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    companyName?: string | undefined;
    customerAccountNumber?: string | undefined;
    accountId?: string | undefined;
    contactId?: string | undefined;
    kamInfo?: BioGaiaContact | undefined;
    samInfo?: BioGaiaContact | undefined;
    artwork?: string | undefined;
    currency?: string | undefined;
    companies?: Company[] | undefined;
}

export class UserRequest implements IUserRequest {
    email?: string | undefined;

    constructor(data?: IUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): UserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IUserRequest {
    email?: string | undefined;
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}